module.exports = __webpack_public_path__ + "static/maquete_4k-eeebcf1651bae011396d515daa1f45fa.webp";